/**
 * RGM Landing page (`/home`) — centralized data-testid registry.
 *
 * Convention (docs/design/data_testid_playbook.md): `rgm_home_{element}[_{stable_id}]`.
 * Dynamic ids take the config/BFF id so a tenant with different screens still produces
 * stable selectors.
 */

import { slugifyTestIdSegment } from 'constants/ppaTestIds';

export const RGM_HOME_PAGE = 'rgm_home_page';

// --- Hero ---
export const RGM_HOME_HERO = 'rgm_home_hero';
export const RGM_HOME_SEARCH_INPUT = 'rgm_home_search_input';

// --- Executive Summary ---
export const RGM_HOME_EXEC_SUMMARY = 'rgm_home_exec_summary';
export const RGM_HOME_EXEC_SUMMARY_SKELETON = 'rgm_home_exec_summary_skeleton';
export const RGM_HOME_EXEC_SUMMARY_ERROR = 'rgm_home_exec_summary_error';
export const RGM_HOME_EXEC_SUMMARY_VIEW_MORE = 'rgm_home_exec_summary_view_more';

export const rgmExecSummaryCardTestId = (id: string): string => `rgm_home_exec_summary_card_${id}`;
export const rgmExecSummaryValueTestId = (id: string): string => `rgm_home_exec_summary_value_${id}`;
export const rgmExecSummaryDeltaTestId = (id: string): string => `rgm_home_exec_summary_delta_${id}`;

// --- AI Intelligent Studio ---
export const RGM_HOME_STUDIO = 'rgm_home_studio';
export const RGM_HOME_STUDIO_GRID = 'rgm_home_studio_grid';
export const RGM_HOME_STUDIO_PANEL = 'rgm_home_studio_panel';
export const RGM_HOME_STUDIO_PANEL_CLOSE = 'rgm_home_studio_panel_close';

export const rgmStudioCardTestId = (key: string): string => `rgm_home_studio_card_${key}`;
export const rgmStudioCardIconTestId = (key: string): string => `rgm_home_studio_icon_${key}`;
export const rgmStudioViewMoreTestId = (key: string): string => `rgm_home_studio_view_more_${key}`;
export const rgmStudioColumnTestId = (key: string, column: string): string =>
    `rgm_home_studio_column_${key}_${slugifyTestIdSegment(column)}`;
export const rgmStudioRouteTestId = (key: string, routeId: string): string =>
    `rgm_home_studio_route_${key}_${slugifyTestIdSegment(routeId)}`;

// --- Recent activities ---
export const RGM_HOME_RECENT_ACTIVITIES = 'rgm_home_recent_activities';
export const rgmRecentActivityRowTestId = (id: string): string => `rgm_home_recent_activity_${id}`;

// --- Hero search panel ---
export const RGM_HOME_SEARCH_PANEL = 'rgm_home_search_panel';
export const RGM_HOME_SEARCH_SEND = 'rgm_home_search_send';
export const RGM_HOME_SEARCH_SHORTCUT = 'rgm_home_search_shortcut';
export const RGM_HOME_SEARCH_AI_MODE = 'rgm_home_search_ai_mode';
export const RGM_HOME_SEARCH_PLACEHOLDERS = 'rgm_home_search_placeholders';
export const RGM_HOME_SEARCH_SUGGESTIONS = 'rgm_home_search_suggestions';
export const RGM_HOME_SEARCH_RESULTS = 'rgm_home_search_results';
export const RGM_HOME_SEARCH_EMPTY = 'rgm_home_search_empty';

export const rgmSearchPlaceholderTestId = (id: string): string => `rgm_home_search_placeholder_${id}`;
export const rgmSearchSuggestionTestId = (id: string): string =>
    `rgm_home_search_suggestion_${slugifyTestIdSegment(id)}`;
export const rgmSearchResultTestId = (id: string): string => `rgm_home_search_result_${slugifyTestIdSegment(id)}`;
